<template>
  <v-autocomplete
    ref="auditor"
    :label="title"
    v-model="selected"
    :items="items"
    :item-text="nombreCompleto"
    item-value="uuid"
    :rules="rules"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
    return-object
    @change="$emit('input', selected)"
  ></v-autocomplete>
</template>

<script>
import format from '~/util/formatHelper'
import moment from 'moment'

export default {
  name: 'SelectAuditoresObject',
  props: {
    value: Object,
    title: { type: String, default: 'Auditor' },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideDetails: { type: String, default: 'auto' },
    subalcance: { type: String, default: '' },
    auditorOrigen: { type: String, default: '' },
  },
  mounted() {
    if (this.required) {
      this.rules = [(v) => !!v || 'Obligatorio']
    }
    this.getItems()
  },
  data(ctx) {
    return {
      rules: [],
      selected: ctx.value,
      items: [],
    }
  },
  methods: {
    nombreCompleto(item) {
      return format.fullName(item)
    },
    isVigenciaActiva(afinidad) {
      const today = moment()
      const desde = moment(afinidad.desde)
      const hasta = moment(afinidad.hasta)
      return today.isSameOrAfter(desde) && today.isSameOrBefore(hasta)
    },
    filtraThisAuditoresItems(array, tipoCompetenciaParaBuscar) {
      if (!tipoCompetenciaParaBuscar) {
        this.items = []
        return
      }
      this.items = array.filter(auditor =>
        auditor.afinidades?.some(af => {
          const isSubalcance = af.subalcance?.uuid === this.subalcance || af.subalcance === this.subalcance
          const isCompetencia = Array.isArray(af.nivelCompetencia)
                                ? af.nivelCompetencia.some(c => String(c).toUpperCase().includes(tipoCompetenciaParaBuscar))
                                : String(af.nivelCompetencia || '').toUpperCase().includes(tipoCompetenciaParaBuscar)
          const isValidDate = this.isVigenciaActiva(af)

          /*console.log({
            auditor: auditor.uuid,
            subalcance: af.subalcance?.uuid,
            isSubalcance,
            nivel: af.nivelCompetencia,
            isCompetencia,
            isValidDate
          })*/
          return isSubalcance && isCompetencia && isValidDate
        })
      )
    },
    async getItems() {
      const res = await this.$store.dispatch('auditores/list')
      if (res) {
        this.items = res.filter((item) => item.user?.activo)
        this.filtraThisAuditoresItems(res, 'COMPETENCIA_CERTIFICADOR')
        //console.log('-> this.items', this.items)
      }
    },
  },
  watch: {
    value: function (val) {
      if (!val || val === undefined) this.$refs.auditor.reset()
      this.selected = val
    },
  },
}
</script>
